import { ButtonComponent } from '@/components/commons'
import { Title } from '@/components/commons/typography/Title'
import { LoaderSpinner } from '@/components/ui/LoaderSpinner.component'
import { PlusIcon } from '@/public/assets/v2/images/icons'
import { Menu, Modal } from '@mantine/core'
import { useCreateProject } from 'containers/projects/hooks/useProjects'
import { PROJECT_TEMPLATES } from 'containers/projects/misc/templates'
import { ProjectStateTypes } from 'containers/projects/types/project'
import { useEffect, useState } from 'react'

export const TemplateSelector = () => {
  const { mutateAsync, isLoading } = useCreateProject()
  const [timeToClose, setTimeToClose] = useState(false)
  const [projectCreated, setProjectCreated] = useState(false)
  const [showModal, setShowModal] = useState(false)


  useEffect(() => {
    if (timeToClose && projectCreated) {
      setShowModal(false)
    }
  }, [timeToClose, projectCreated])


  const onSelectProject = async (templateId: string) => {
    setShowModal(true)
    const templateSelected = PROJECT_TEMPLATES.find((t) => t.id === templateId)!

    setTimeout(() => {
      setTimeToClose(true)
    }, 3000)

    try {
      await mutateAsync({
        ...templateSelected.project,
        state: ProjectStateTypes.DRAFT,
        templateId,
      })
    } catch (error) {
      console.error(error)
    } finally {
      setProjectCreated(true)
    }
  }
  
  return (
    <div>
      <Modal 
        opened={isLoading || showModal} 
        onClose={() => null} 
        size="xl" 
        withCloseButton={false} 
        closeOnClickOutside={false} 
        className='--v2'
        centered
        closeOnEscape={false}>
        <div className='flex flex-column align-center items-center justify-space-between py-40 gap-20'>
          <Title variation='h3' sizeClass='text-24' className='text-center'>
            Your draft template will appear in the Projects section of your profile, and you’ll be able to edit and publish your template from there!
          </Title>
          <LoaderSpinner size={50} />
        </div>
      </Modal>
      <Menu shadow="md" width={200} position="bottom-end">
        <Menu.Target>
          <ButtonComponent
            size="xSmall"
            label="Templates"
            variation="secondary"
            iconLeft={<PlusIcon className="text-14 text-secondary" />}
          />
        </Menu.Target>

        <Menu.Dropdown>
          {PROJECT_TEMPLATES.map((template) => (
            <Menu.Item key={template.id} leftSection={template.icon} onClick={() => onSelectProject(template.id)}>
              {template.title}
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    </div>
  )
}
